class scrolling {
    constructor( gsap ) {

        /* spent-on-site-timer */
        var timerStart;
        var timeSpentOnSite = getTimeSpentOnSite();
        var timeSpent;

        function getTimeSpentOnSite(){
            timeSpentOnSite = parseInt(localStorage.getItem('timeSpentOnSite'));
            timeSpentOnSite = isNaN(timeSpentOnSite) ? 0 : timeSpentOnSite;
            return timeSpentOnSite;
        }

        function updateTimeSpentOnSite(){
            timeSpentOnSite = getTimeSpentOnSite() + (Date.now() - timerStart);
            localStorage.setItem('timeSpentOnSite',timeSpentOnSite);
            timerStart = parseInt(Date.now());
            timeSpent = parseInt((timeSpentOnSite / 1000) / 60) + 'minutes';
            document.getElementById("timer").innerHTML = timeSpent;
            document.getElementById("timer_message").classList.remove('hidden');
        }

        timerStart = Date.now();

        /* create BG-noise */
        const canvas = document.querySelector("#robert_irwin .noise")
        const ctx = canvas.getContext("2d")

        canvas.width = window.innerWidth
        canvas.height = window.innerHeight

        function generateNoise() {
            /* static noise */
            const imageData = ctx.createImageData(canvas.width, canvas.height)
            const data = imageData.data
            for (let i = 0; i < data.length; i += 4) {
                data[i] = Math.random() * 255     // Red
                data[i + 1] = Math.random() * 255 // Green
                data[i + 2] = Math.random() * 255 // Blue
                data[i + 3] = 255                 // Alpha (fully opaque)
            }
            ctx.putImageData(imageData, 0, 0)
        }

        generateNoise()
        /* */

        let ticking = false;

        // check if Browser can handle scroll-end
        if ('onscrollend' in window) {
            addEventListener("scrollend", (event) => {
                updateTimeSpentOnSite();
                generateNoise();
                /*
                let lastLinkTranslation = this.getTranslation(document.querySelector('aside > nav > ul > li:last-of-type'))
                if( (lastLinkTranslation.y * (-1)) >= ( (window.innerWidth / 100 * 3) + 40 ) ){ 
                    document.querySelectorAll('body > aside nav a').forEach(link => {
                        link.parentNode.classList.add("blurred")
                    })
                }else{
                    document.querySelectorAll('body > aside nav a').forEach(link => {
                        link.parentNode.classList.remove("blurred")
                    })
                } */
            });
        }
        
        // throttle scrolling event
        document.addEventListener('scroll', (event) => {
            
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.updateScrolling( gsap );
                    ticking = false;
                });
                ticking = true;
            };

        }, false);

        window.addEventListener('load', (event) => { 

            this.updateScrolling( gsap );
            
        })

    }

    // Function to extract the translation values
    getTranslation(element) {

        const style = window.getComputedStyle(element);
        const matrix = style.transform;

        if (matrix === 'none') {
            return { x: 0, y: 0 }; // No translation applied
        }

        // Extract matrix values (browser outputs in matrix(a, b, c, d, tx, ty) or matrix3d)
        const values = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');

        const is3D = matrix.includes('matrix3d');

        const x = is3D ? parseFloat(values[12]) : parseFloat(values[4]);
        const y = is3D ? parseFloat(values[13]) : parseFloat(values[5]);

        return { x, y };

    }

    updateScrolling( gsap){

        // basic values
        let moveLink = 0;
        let scrollPosition = window.scrollY;

        // check if navigation is visible and spread it across the screen
        if(document.querySelector('body > aside') && document.querySelector('body > aside').style.display != 'none'){

            const navLinks = document.querySelectorAll('body > aside nav a');
            navLinks.forEach(link => {

                // get target element by ID
                const targetId = link.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                
                // check distances of content
                let targetOffset = parseFloat( targetElement.offsetTop );
                let paddingSection = parseFloat( window.getComputedStyle(targetElement, null).getPropertyValue('padding-top') );
                let paddingHeadline = parseFloat( window.getComputedStyle(targetElement.querySelector(".headlineblock:first-child h2"), null).getPropertyValue('padding-top') );
                
                // check distances of link
                let navigationOffset = parseFloat( document.querySelector('body > aside nav').offsetTop );
                let linkOffset = parseFloat( link.parentNode.offsetTop );
                let offsetdifference = linkOffset - navigationOffset;
                let linkMaxDistance = linkOffset - ( paddingSection + paddingHeadline ) - offsetdifference;

                // calculate how far this link should be moved
                moveLink = ( linkMaxDistance / ( targetOffset - offsetdifference ) ) * scrollPosition * (-1)

                // move link
                if( moveLink <= linkMaxDistance * (-1) ){
                    moveLink = linkMaxDistance * (-1);
                }else if( scrollPosition <= 0 ){
                    moveLink = 0;
                }

                gsap.to(link.parentNode, {
                    y: moveLink,
                    duration: 0.45,
                    ease: "power2.out"
                })

            });

            // check how far last link has been moved and if scroll up should be shown
            const lastLink = document.querySelector('aside > nav > ul > li:last-of-type')
            let lastLinkTranslation = this.getTranslation(lastLink)

            if( (lastLinkTranslation.y * (-1)) >= ( (window.innerWidth / 100 * 3) + 40 ) ){ 
                document.querySelector('aside > nav + div').classList.add("visible")
                /* if (!'onscrollend' in window) {
                    navLinks.forEach(link => {
                        link.parentNode.classList.add("blurred")
                    })
                } */
            }else{ 
                document.querySelector('aside > nav + div').classList.remove("visible") 
                /* if (!'onscrollend' in window) {
                    navLinks.forEach(link => {
                        link.parentNode.classList.remove("blurred")
                    })
                } */
            }
                
        }

    }

}

export default scrolling